export default {
  'globals.yes': 'Ja',
  'globals.no': 'Neen',
  'globals.download': 'Download',
  'globals.featuredProducts': 'aanbevolen producten',
  'header.search.placeholder': 'zoeken',
  'header.selectlanguage': 'Selecteer Taal',
  'footer.copyright': '© {year} Arvesta. All rights reserved.',
  'footer.newsletter.heading':
    'Wil jij nieuwtjes en advies ontvangen die aansluiten bij wat jóu interesseert? Doen we graag voor je!',
  'footer.newsletter.subscribe': 'Inschrijven',
  'footer.newsletter.placeholder': 'Vul je email adres in',
  'footer.newsletter.success': 'Dank je wel. We hebben je gegevens goed genoteerd. Tot binnenkort!',
  'footer.newsletter.error': 'Er is een fout opgetreden met de informatie die je hebt ingevoerd, probeer het opnieuw.',
  'footer.subscribe.enteremail': 'Vul je email adres in',
  'footer.subscribe.subscribe': 'Inschrijven',
  'footer.subscribe.belgium': 'België',
  'footer.subscribe.netherlands': 'Nederland',
  'footer.subscribe.countryLabel': 'Land',
  'footer.subscribe.invalid_email': 'Kan je nog even je e-mailadres ingeven?',
  'footer.subscribe.invalid_country': 'Kan je nog even je land ingeven?',
  'footer.subscribe.success': 'Dank je wel. We hebben je gegevens goed genoteerd. Tot binnenkort!',
  'footer.subscribe.failure': 'Er is een fout opgetreden met de informatie die je hebt ingevoerd, probeer het opnieuw.',
  'footer.subscribe.subscribing': 'Even geduld aub, we proberen verbinding te maken met de server',
  'product.certifications.title': 'Productcertificeringen',
  'forms.contact.errors.required': 'Vul je nog even dit verplichte veld in?',
  'forms.contact.errors.email': 'Kan je nog even je e-mailadres ingeven?',
  'forms.contact.failure': 'Er is een fout opgetreden met de informatie die je hebt ingevoerd, probeer het opnieuw.',
  'forms.contact.success': 'Dank je. We bekijken je bericht. ',
  'forms.contact.title': 'Neem contact met ons op ',
  'forms.contact.description': 'Vul het onderstaande formulier in en ons team neemt contact met u op.',
  'forms.contact.fullname.label': 'Voor-en achternaam',
  'forms.contact.fullname.placeholder': 'Vul je volledige naam in',
  'forms.contact.email.label': 'E-mailadres',
  'forms.contact.email.placeholder': 'Vul je e-mailadres in',
  'forms.contact.message.label': 'Bericht',
  'forms.contact.message.placeholder': 'Vul je bericht in ',
  'forms.contact.newsletter.title':
    'Wil jij nieuwtjes en advies ontvangen die aansluiten bij wat jóu interesseert? Doen we graag voor je!',
  'forms.contact.submit': 'Versturen',
  'sections.dealer.placeholder': 'Vul je postcode en gemeente in',
  'sections.dealer.loadmore': 'Toon alles',
  'sections.dealer.invalidaddress': 'We konden dit adres niet vinden',
  'sections.dealer.search': 'Zoeken',
  'sections.dealer.maplink': 'Bekijk op google maps',
  'sections.dealer.total': 'resultaten voor',
  'sections.dealer.clear': 'Wissen',
  'sections.search.results.title': '{total} resultaten voor {query}',
  'sections.search.noresults.title': 'Sorry we hebben geen resultaten gevonden voor ',
  'cards.category.link': 'Bekijk meer',
  'cards.product.link': 'Bekijk meer',
  'cards.event.link': 'Bekijk event',
  'cards.news.link': 'Lees verder',
  'cards.advice.link': 'Lees artikel',
  'sections.events.loadmore': 'Laad meer evenementen',
  'sections.events.loadmorepast': 'Laad meer evenementen uit het verleden',
  'sections.advice.loadmore': 'Laad meer advies',
  'sections.news.loadmore': 'Laad meer nieuwsitems',
  'sections.product.loadmore': 'Laad meer',
  'sections.category.loadmore': 'laad meer',
  'sections.product.noproductsfoundfor': 'geen producten gevonden voor',
  'sections.product.table.number': 'art.nr',
  'sections.product.table.product': 'product',
  'sections.product.table.weight': 'gewicht',
  'sections.product.table.brochure': 'brochure',
  'sections.product.table.download': 'Download',
  'sections.contact.offices': 'kantoren',
  'sections.contact.salesteam': 'Team',
  'sections.contact.viewonmap': 'Bekijk op google maps',
  'sections.contact.openinghours': 'openingstijden',
  'legacy.cookie.description': 'Met het bezoeken van deze website gaat u akkoord met ons gebruik van',
  'legacy.header.products': 'producten & diensten',
  'legacy.header.about': 'over ons',
  'legacy.header.news': 'nieuws & pers',
  'legacy.header.jobs': 'jobs',
  'legacy.header.contact': 'contacteer ons',
  'legacy.footer.headoffice': 'Hoofdkantoor',
  'legacy.footer.headquarters': 'Maatschappelijke zetel',
  'sections.search.products': 'products',
  'sections.search.news': 'News',
  'sections.search.events': 'Events',
  'sections.search.noncategorised': 'Non - categorised',
  'sections.search.seeallproducts': 'See all Products',
  'sections.search.seeallevents': 'See all Events',
  'sections.search.seeallnews': 'See all News',
  'brandListing.byCategories': 'By categories',
  'brandListing.seeProductsFor': 'See products for',
  'brandListing.productsAndServices': 'Products & Services',
  'brandListing.similarBrands': 'Brands with similar products & services',
  'brandListing.visitWebsite': 'Visit Website',
  'brandListing.all': 'All',
  'brandListing.clear': 'Wissen',
};
